const ARIA_EXPANDED = 'aria-expanded';
const ARIA_DISABLED = 'aria-disabled';

/**
 * @description CorePaymentAccordionItem implementation
 * @param PaymentAccordionItem widget
 * @returns Payment Tab Panel class
 */
function CorePaymentAccordionItemClassCreator(PaymentAccordionItem: import('widgets/checkout/PaymentAccordionItem').TPaymentAccordionItem) {
    /**
     * @category widgets
     * @subcategory checkout
     * @class CorePaymentAccordionItem
     * @augments PaymentAccordionItem
     */
    class CorePaymentAccordionItem extends PaymentAccordionItem {
        prefs() {
            return {
                classesOpened: 'm-opened',
                ...super.prefs()
            };
        }

        /**
         * @description Opens payment accordion panel and toggle Billing Form, if Billing Form has to be presented for chosen Payment Accordion Item
         * Same as in parent, with ability to prevent event emitting
         */
        openPanel(emitEvent = true) {
            if (!this.isMultipleSections) {
                /**
                 * @description Event to close all items
                 * @event AccordionItem#closeallitems
                 */
                this.emit('closeallitems');
            }

            this.has(this.prefs().accordionItemBtn, accordionItemBtn => {
                accordionItemBtn.attr(ARIA_EXPANDED, 'true');

                if (!this.isToggleAllowed) {
                    accordionItemBtn.attr(ARIA_DISABLED, 'true');
                }
            });
            this.has(this.prefs().accordionItemPanel, accordionItemPanel => this.togglePanelHeight(true, accordionItemPanel));

            this.isPanelOpen = true;

            if (emitEvent) {
                /**
                 * @description Event for opening panel
                 * @event AccordionItem#openpanel
                 */
                this.emit('openpanel');
            }

            const hasToBeHidden = this.prefs().skipBillingAddress;

            this.emit('togglebillingform', !hasToBeHidden);

            this.eventBus().emit('checkout.paymentmethod.updated', {
                name: this.prefs().methodName,
                id: this.prefs().methodId
            });

            this.ref('self').addClass(this.prefs().classesOpened);
        }

        /**
         * @description Handles panel close
         */
        closePanel() {
            super.closePanel();

            this.ref('self').removeClass(this.prefs().classesOpened);
        }
    }

    return CorePaymentAccordionItem;
}

export type TCorePaymentAccordionItem = ReturnType<typeof CorePaymentAccordionItemClassCreator>;

export type TCorePaymentAccordionItemInstance = InstanceType<TCorePaymentAccordionItem>;

export default CorePaymentAccordionItemClassCreator;
